var exports = {
  "IL": "ConfirmModal.module__messagePreview___WklvR0",
  "sA": "ConfirmModal.module__messagePreviewOverflowing___WklvR0",
  "ey": "ConfirmModal.module__shiftBypassTip___WklvR0",
  "iH": "ConfirmModal.module__shiftBypassTipLabel___WklvR0",
};

module.exports = exports;
